import template from './kform-script-editor.html';
import controller from './kform-script-editor.controller';

export default {
	bindings: {
		ngModel: '=',
		rows: '<?',
		placeholder: '@?',
	},
	controller,
	controllerAs: '$ctrl',

	require: {
		ngModelCtrl: '?ngModel',
	},

	template,
};
